import { useNavigate } from "react-router-dom";

const NoPage = () => {
  const navigate = useNavigate();

  return (
    <div className="text-center p-1" style={section}>
      <div className="logo-holder">
        <img alt="404-logo" src="https://assets.cure.com/img/main-site/cure-main-404.png" style={logoStyle} />
        <h3 style={headingStyle}>We could not find that page.</h3>
      </div>

      <div className="text-center my-4">
        <input
          type={"button"}
          className="btn btn-primary-grad"
          value={"Return to My Account Home"}
          onClick={() => navigate('/home')}
        />
      </div>
    </div>
  );
};

const section = {
  marginTop: '100px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  textAlign: 'center',
  padding: '1rem'
}

const logoStyle = {
  width: '100%',
  maxWidth: '500px',
  height: 'auto'
}

const headingStyle = {
  marginTop: '20px',
  fontSize: '1.5rem'
};

export default NoPage;